// Create a new file: /components/execution/GlobalStateModal.jsx

import React from 'react';

import Modal from '../base/Modal'; // Assuming path to your base modal
import OutputRenderer from './OutputRenderer'; // Assuming path to your renderer

const GlobalStateModal = ({ globalState, onClose }) => {
  return (
    <Modal title="Live Global State" isOpen={true} onClose={onClose}>
      <div className="max-h-[70vh] overflow-y-auto rounded-b-lg bg-zinc-900 p-6">
        {globalState ? (
          <OutputRenderer content={JSON.stringify(globalState, null, 2)} />
        ) : (
          <div className="py-8 text-center text-slate-400">
            No global state has been initialized for this execution.
          </div>
        )}
      </div>
    </Modal>
  );
};

export default GlobalStateModal;
